import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Menu1X3Hollow = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 26C12 23.8 13.8 22 16 22C18.2 22 20 23.8 20 26C20 28.2 18.2 30 16 30C13.8 30 12 28.2 12 26ZM18 26C18 24.9 17.1 24 16 24C14.9 24 14 24.9 14 26C14 27.1 14.9 28 16 28C17.1 28 18 27.1 18 26Z" />
		<path d="M16 20C13.8 20 12 18.2 12 16C12 13.8 13.8 12 16 12C18.2 12 20 13.8 20 16C20 18.2 18.2 20 16 20ZM16 14C14.9 14 14 14.9 14 16C14 17.1 14.9 18 16 18C17.1 18 18 17.1 18 16C18 14.9 17.1 14 16 14Z" />
		<path d="M12 6C12 3.8 13.8 2 16 2C18.2 2 20 3.8 20 6C20 8.2 18.2 10 16 10C13.8 10 12 8.2 12 6ZM18 6C18 4.9 17.1 4 16 4C14.9 4 14 4.9 14 6C14 7.1 14.9 8 16 8C17.1 8 18 7.1 18 6Z" />
	</svg>
);

export default Menu1X3Hollow;
